import { render } from "./NextSteps.vue?vue&type=template&id=95daaf36&scoped=true"
import script from "./NextSteps.vue?vue&type=script&lang=js"
export * from "./NextSteps.vue?vue&type=script&lang=js"

import "./NextSteps.vue?vue&type=style&index=0&id=95daaf36&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95daaf36"]])

export default __exports__